import React, { useEffect, useRef, useState } from 'react';

import PropTypes from 'prop-types';

import ModalPortal from 'components/utils/ModalPortal';

import { URL_IMAGES_I } from 'constants/UrlConstants';

import { LightNavBar } from '../common/fromAuth/LightNavBar/LightNavBar';

const Video = (props) => {
    const [isShowVideo, setShowVideo] = useState(false);
    const movieRef = useRef(null);

    useEffect(() => {
        const keyPressHandler = ({ keyCode }) => {
            if (keyCode === 27) {
                document.body.style.overflow = '';
                setShowVideo(false);
            }
        };
        if (__isBrowser__) {
            document.addEventListener('keydown', keyPressHandler);
        }
        return () => {
            if (__isBrowser__) {
                document.removeEventListener('keydown', keyPressHandler);
            }
        };
    }, []);

    const overlayClick = (e) => {
        if (isShowVideo && movieRef.current && !movieRef.current.contains(e.target)) {
            toggleVideo(e);
        }
    };

    const toggleVideo = (e) => {
        e.preventDefault();
        document.body.style.overflow = !isShowVideo ? 'hidden' : '';
        setShowVideo(!isShowVideo);
    };

    const currency_to_code = props.extra?.currency_to_code ?? 'poster';

    const countryFrom = props.countryMenu?.countryFrom;

    const getPreviewImage = () => {
        if (props.isRequest) {
            return (
                <picture>
                    <source
                        className=" lazyloading"
                        media="(min-width: 1040px)"
                        srcSet={`${URL_IMAGES_I}/request-${currency_to_code}-c.png 1x, ${URL_IMAGES_I}/request-${currency_to_code}-c@2x.png 2x`}
                    />
                    <source
                        className=" lazyloading"
                        media="(min-width: 656px)"
                        srcSet={`${URL_IMAGES_I}/request-${currency_to_code}-b.png 1x, ${URL_IMAGES_I}/request-${currency_to_code}-b@2x.png 2x`}
                    />
                    <source
                        className=" lazyloading"
                        srcSet={`${URL_IMAGES_I}/request-${currency_to_code}-a.png 1x, ${URL_IMAGES_I}/request-${currency_to_code}-a@2x.png 2x`}
                    />
                    <img
                        className=" lazyloaded"
                        loading="lazy"
                        decoding="async"
                        alt="How to request money"
                        srcSet={`${URL_IMAGES_I}/request-${currency_to_code}.png`}
                        height="709"
                        width="960"
                    />
                </picture>
            );
        }
        if (countryFrom?.code === 'us') {
            return (
                <picture>
                    <source
                        className="lazyloading"
                        media="(min-width: 1040px)"
                        srcSet={`${URL_IMAGES_I}/usa-poster-c.webp 1x, ${URL_IMAGES_I}/usa-poster-c@2x.webp 2x`}
                    />
                    <source
                        className="lazyloading"
                        media="(min-width: 656px)"
                        srcSet={`${URL_IMAGES_I}/usa-poster-b.webp 1x, ${URL_IMAGES_I}/usa-poster-b@2x.webp 2x`}
                    />
                    <source className="lazyloading" srcSet={`${URL_IMAGES_I}/usa-poster-a.webp 1x, ${URL_IMAGES_I}/usa-poster-a@2x.webp 2x`} />
                    <img
                        className="lazyloaded"
                        loading="lazy"
                        decoding="async"
                        alt="Video poster"
                        srcSet={`${URL_IMAGES_I}/usa-poster-c.webp`}
                        height="620"
                        width="960"
                    />
                </picture>
            );
        }
        return (
            <picture>
                <source className=" lazyloading" media="(min-width: 1040px)" srcSet={`${URL_IMAGES_I}/poster-c.png 1x, ${URL_IMAGES_I}/poster-c@2x.png 2x`} />
                <source className=" lazyloading" media="(min-width: 656px)" srcSet={`${URL_IMAGES_I}/poster-b.png 1x, ${URL_IMAGES_I}/poster-b@2x.png 2x`} />
                <source className=" lazyloading" srcSet={`${URL_IMAGES_I}/poster-a.png 1x, ${URL_IMAGES_I}/poster-a@2x.png 2x`} />
                <img
                    className=" lazyloaded"
                    loading="lazy"
                    decoding="async"
                    alt="Video poster"
                    srcSet={`${URL_IMAGES_I}/poster.png`}
                    height="709"
                    width="960"
                />
            </picture>
        );
    };

    const getVideoFrame = (
        <ModalPortal>
            <div className="overlay" id="video">
                <LightNavBar>
                    <a className="icon-box" id="closeMovie" onClick={toggleVideo}>
                        <svg xmlns="http://www.w3.org/2000/svg" className="svg-icon-close" height="14" width="14" viewBox="0 0 14 14" version="1.1">
                            <g strokeLinecap="round" strokeMiterlimit="10" strokeWidth="2" stroke="#141414" fill="none">
                                <line y2="1" x2="13" y1="13" x1="1"></line>
                                <line y2="1" x2="1" y1="13" x1="13"></line>
                            </g>
                        </svg>
                    </a>
                </LightNavBar>
                <div className="modal-win-outer" onClick={overlayClick}>
                    <div className="modal-win-inner">
                        <div id="movieFrame" ref={movieRef}>
                            <iframe
                                src={props.url}
                                width="100%"
                                height="100%"
                                frameBorder="0"
                                allow="autoplay; encrypted-media;accelerometer; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen="1"
                                title={''}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </ModalPortal>
    );

    return (
        <div className="video-poster">
            <figure className="illustration" id="illustration">
                {getPreviewImage()}
            </figure>
            <a className="button-icon" id="watchMovie" onClick={toggleVideo} title="Play video" tabIndex={'0'} />
            {isShowVideo && getVideoFrame}
        </div>
    );
};

Video.propTypes = {
    url: PropTypes.string.isRequired,
};

export default Video;
